import { Component, inject, output, ChangeDetectionStrategy } from '@angular/core';
import { ScreenSizeService } from '../../services/screen-size-service/screen-size.service';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { UserService } from '../../auth/user-service/user.service';

@Component({
    selector: 'app-nav',
    imports: [RouterLink, RouterLinkActive, MatIconModule, MatMenuModule, MatButtonModule],
    templateUrl: './nav.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './nav.component.css',
})
export class NavComponent {
    // Injectables
    screenSizeService = inject(ScreenSizeService);
    router = inject(Router);
    protected userService = inject(UserService);

    // Signals
    screenSize = this.screenSizeService.screenSize;

    // Outputs
    logout = output();
}
